import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { simCardSelector } from '../../selectors/simcards';
import { getExportSimcardsRequest, closePingEventExportSimcards, getSimcardsSubstatusesRequest, getSimcardsStatusesRequest } from '../../actions/simcards';
import { setSimcardsFilters } from '../../actions/filters';
import { filtersSimcardsSelector, filtersSimcardsToUseInQuerySelector } from '../../selectors/filters';
import FiltersSimcards from './FiltersSimcards';

const mapStateToProps = createStructuredSelector({
    simCards: simCardSelector,
    filters: filtersSimcardsSelector,
    filtersToUseInQuery: filtersSimcardsToUseInQuerySelector
});

const mapDispatchToProps = {
    setSimcardsFilters,
    getExportSimcardsRequest,
    closePingEventExportSimcards,
    getSimcardsSubstatusesRequest,
    getSimcardsStatusesRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(FiltersSimcards);
